var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7357 0.808594H2.54557C1.19492 0.808594 0.0898438 1.91367 0.0898438 3.26432V20.4544C0.0898438 21.8051 1.19492 22.9102 2.54557 22.9102H19.7357C21.0863 22.9102 22.1914 21.8051 22.1914 20.4544V3.26432C22.1914 1.91367 21.0863 0.808594 19.7357 0.808594ZM7.45703 17.9987H5.0013V9.40365H7.45703V17.9987ZM12.3685 17.9987H9.91276V5.72005H12.3685V17.9987ZM17.2799 17.9987H14.8242V13.0872H17.2799V17.9987Z",
    fill: "#01537A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingIcon);
export default __webpack_public_path__ + "static/media/reportingIcon.2e94cb1954b5dc9c5ef064bdd0958616.svg";
export { ForwardRef as ReactComponent };